import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

import news from "@/views/news";
import instructions from "@/views/instructions";
import console from "@/views/console";
import developers from "@/views/developers";
import appDetail from "@/views/developers/appDetail";
import login from "@/views/login";
import register from "@/views/register";
import resetPw from "@/views/resetPw";
import Layout from "@/components/Layout.vue";
import ElementUI from 'element-ui';

Vue.use(Router);
// 路由需要登录才可进入
const whiteList= [
   '/console', '/developers',
]

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/", //首页
      name: "home",
      component: Home,
    },
    {
      path: "/news",
      component: news,
      name: "news",
      meta: { title: "新闻动态" },
    },
    {
      path: "/instructions",
      name: "instructions",

      component: instructions,
      meta: { title: "使用说明" },
    },
    {
      path: "/console",
      component: console,
      name: "console",

      meta: { title: "控制台" },
    },
    {
      path: "/developers",
      component: developers,
      name: "developers",

      meta: { title: "企业开发者" },
    },

    {
      path: "/appDetail",
      component: appDetail,
      name: "appDetail",

      meta: { title: "新增企业开发者" },
    },

    {
      path: "/login",
      component: login,
      name: "login",

      meta: { title: "注册" },
    },
    {
      path: "/register",
      component: register,
      name: "register",

      meta: { title: "登录" },
    },
    {
      path: "/resetPw",
      component: resetPw,
      name: "resetPw",

      meta: { title: "忘记密码" },
    },
  ],
  
});


// 全局前置路由守卫：初始化时执行、每一次路由切换之前调用
router.beforeEach((to,from,next)=>{
  if (to.name == from.name) {
    return 
  }
  // next()  //没有next所有的路由跳转都无效
  if(whiteList.indexOf(to.path) > -1){  //判断是否需要鉴权，就不用to.path === '/home/news' || to.path === '/home/msg'
    if(localStorage.getItem('user')){  //权限控制的具体规则
      if (to.path== '/developers') {
        if (JSON.parse(localStorage.getItem('user')).personType ==1) {
          next()
        }else {
          ElementUI.Message({
              message: '您不是企业开发者，请登录！',
              type: 'info'
          });
          return
        }
      }
      if (to.path== '/console') {
        if (JSON.parse(localStorage.getItem('user')).personType ==0) {
          next()
        }else {
          ElementUI.Message({
              message: '您不是个人用户，请登录！',
              type: 'info'
          });
          return
        }
      }
      next()
    }else{
      ElementUI.Message({
          message: '暂无权限查看,请先登录后再来查看此页面！',
          type: 'info'
      });
      if (from.path== '/login') {
        return 
      }
      next('/login')
    }
  }else{
    next()
  }
})

export default router